<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2019 (original work) Open Assessment Technologies SA ;
    import { Icon } from '@oat-sa-private/ui-elements';
    export let data;
</script>

<style>
    .icon {
        text-align: center;
    }
</style>

<div class="icon">
    <Icon {...data} />
</div>
